export default "__VITE_ASSET__ZSx6MNji__"